import { render, staticRenderFns } from "./changLianConfig.vue?vue&type=template&id=22c85693&scoped=true"
import script from "./changLianConfig.vue?vue&type=script&lang=js"
export * from "./changLianConfig.vue?vue&type=script&lang=js"
import style0 from "./changLianConfig.vue?vue&type=style&index=0&id=22c85693&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c85693",
  null
  
)

export default component.exports